// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__FMFy_","navigation":"Sidebar_navigation__LIkx3","title":"Sidebar_title__pzTL8"};